import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

export const Footer = () => {
  return (
    <div className="landing-wrapper">
      <section className="hero-section">
        <div className="overlay" />

        <div className="footer-content">
          <div className="text-content" data-aos="fade-up" data-aos-duration="5000">
            <p className="subtitle">A place for prayer and peace.</p>
            <h1 className="title">ADHIE ANNAN TEMPLE</h1>
            <p className="description">
              Adhie Annan Temple is one of the most ancient and historical
              temple in Tamilnadu. Adhie Annan Temple is one of the most ancient
              and historical temple in Tamilnadu.
            </p>
          </div>

          <div className="contact-cards" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">
            <ul className="footer-nav">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/deities">Deities</Link></li>
              <li><Link to="/pooja">Pooja</Link></li>
              <li><Link to="/transport">Transport</Link></li>
              <li><Link to="/support">Support</Link></li>
            </ul>

            <div className="card-Detail">
              <div className="card" data-aos="fade-left" data-aos-delay="500">
                <p className="label">
                  <FontAwesomeIcon icon={faEnvelope} style={{ color: "#AB0000" }} /> Mail Address
                </p>
                <p className="value">adhiedorai@gmail.com</p>
              </div>
              <div className="card" data-aos="fade-left" data-aos-delay="700">
                <p className="label">
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#AB0000" }} /> Phone Number
                </p>
                <p className="value">+91 9341260607</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="footer" >
        © 2025 Techlambdas. All rights reserved.
      </div>
    </div>
  );
};
